import { render, staticRenderFns } from "./details.vue?vue&type=template&id=97475a4c&scoped=true"
import script from "./details.vue?vue&type=script&lang=js"
export * from "./details.vue?vue&type=script&lang=js"
import style0 from "./details.vue?vue&type=style&index=0&id=97475a4c&prod&scoped=true&lang=scss"
import style1 from "./details.vue?vue&type=style&index=1&id=97475a4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97475a4c",
  null
  
)

export default component.exports